<script>
    import {mapState, mapActions, mapGetters} from 'vuex'

    export default {
        props: {},
        data() {
            return {}
        },
        methods: {
            ...mapActions('subsidies/select/form', {
                change: 'change',
            }),
        },
        computed: {
            ...mapState('subsidies/select', {
                form: 'form'
            }),
        },
        watch: {},
        components: {},
        mounted() {

        },
        destroyed() {

        },
    }
</script>
<template>
    <div class="">
        <el-row :gutter="8">
            <el-col :span="12">
                <el-form-item>
                    <dictionary-dates-and-type
                            label-width="130px"
                            :type-value="form.dateType"
                            type-field="dateType"
                            @change-type-field="change"
                            :value="form.dates"
                            field="dates"
                            @change-field="change"
                            type="subsidies">
                    </dictionary-dates-and-type>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <form-input
                            label="Номер:"
                            label-width="130px"
                            :value="form.Number"
                            field="Number"
                            @change-field="change">
                    </form-input>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <dictionary-currency
                            label="Валюта:"
                            label-width="130px"
                            :value="form.CurrencyIds"
                            field="CurrencyIds"
                            @change-field="change"
                            multiple
                            clearable>
                    </dictionary-currency>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <dictionary-subsidies-type
                            label="Тип:"
                            label-width="130px"
                            :value="form.Type"
                            field="Type"
                            @change-field="change"
                            clearable>
                    </dictionary-subsidies-type>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <form-sum
                            label="Доступно от:"
                            label-width="130px"
                            :value="form.AvailableSumFrom"
                            field="AvailableSumFrom"
                            @change-field="change">
                    </form-sum>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <form-sum
                            label="Доступно до:"
                            label-width="130px"
                            :value="form.AvailableSumTo"
                            field="AvailableSumTo"
                            @change-field="change">
                    </form-sum>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <form-sum
                            label="Сумма от:"
                            label-width="130px"
                            :value="form.SumFrom"
                            field="SumFrom"
                            @change-field="change">
                    </form-sum>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <form-sum
                            label="Сумма до:"
                            label-width="130px"
                            :value="form.SumTo"
                            field="SumTo"
                            @change-field="change">
                    </form-sum>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <input-contragent
                            label="Контрагент:"
                            label-width="130px"
                            :value="form.ContragentId"
                            :name="form.ContragentName"
                            @change="change({field: 'Contragent', value: $event})"
                    ></input-contragent>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <dictionary-owner-legal
                            label="Фирма-владельца:"
                            label-width="130px"
                            :value="form.OwnerLegalEntityId"
                            field="OwnerLegalEntityId"
                            @change-field="change"
                            clearable>
                    </dictionary-owner-legal>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="8">
            <el-col :span="12">
                <el-form-item>
                    <el-checkbox
                            :value="form.IsPayed"
                            @change="change({field: 'IsPayed', value: $event})"
                            label="Оплаченные"
                            border
                            style="width: 100%;">
                    </el-checkbox>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item>
                    <el-checkbox
                            :value="form.IsUsed"
                            @change="change({field: 'IsUsed', value: $event})"
                            label="Погашенные"
                            border
                            style="width: 100%;">
                    </el-checkbox>
                </el-form-item>
            </el-col>
        </el-row>
    </div>
</template>
<style lang="scss">
    .select-subsidies-search {
        .el-input-group__prepend {
            width: 130px;
            padding: 0 8px;
            text-align: right;
            color: #333;
        }
    }
</style>
